import React, { useState } from "react";
import {
  MissionCardTask,
  MissionCardTaskCheckbox,
  MissionCardTaskContent,
  MissionCardTaskColumn,
  MissionCardTaskText,
  MissionCardTaskReward,
} from "./MissionsContent.styled";

const MissionTask = ({ text, completed = false, reward, actionHandler, primaryColor }) => {
  const canInteract = !completed && actionHandler;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <MissionCardTask
      onClick={canInteract ? actionHandler : undefined}
      onMouseEnter={() => canInteract && setIsHovered(true)}
      onMouseLeave={() => canInteract && setIsHovered(false)}
      $interactive={canInteract} // Prop for styled-component
      style={{
        cursor: canInteract ? "pointer" : "default",
        // The rest of the styles like display, flexDirection, alignItems are now in MissionCardTask styled-component
      }}
    >
      {/* This div groups checkbox and text content, allowing it to grow and push the arrow to the right */}
      <div
        style={{
          display: "flex",
          alignItems: "start", // Aligns checkbox with the first line of text if text wraps
          flexGrow: 1,
          gap: "0.5rem", // Reduced gap between checkbox and text
        }}
      >
        <MissionCardTaskCheckbox
          style={{marginTop: '-4px'}} // Compensate font offset
          $checked={completed}
          $disabled={true} // Visually indicates non-interactive, actual click is on parent
        />
        <MissionCardTaskContent
          style={{
            width: "100%", // Ensure it takes available width within the flex item
          }}
        >
          <MissionCardTaskColumn style={{ flexGrow: 1, marginRight: "8px" }}>
            <MissionCardTaskText
              $completed={completed}
              $primaryColor={primaryColor}
            >
              {text}
            </MissionCardTaskText>

          </MissionCardTaskColumn>
        </MissionCardTaskContent>
      </div>
      <img
        src="/assets/arrow_right_selection.svg"
        alt="" // Decorative
        style={{
          width: "15px",
          height: "15px",
          rotate: "-45deg",
          marginLeft: "8px", // Add some space between text block and arrow
          flexShrink: 0, // Prevent arrow from shrinking
          visibility: canInteract && isHovered ? "visible" : "hidden", // Control visibility
          transition: "opacity 0.2s ease-in-out, visibility 0.2s ease-in-out", // Smooth transition
        }}
      />
    </MissionCardTask>
  );
};

export default MissionTask;
